import React from 'react';
import { Row, Column, Input, Button } from '../Common';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { colors } from '../variables';

const SearchButton = styled(Button)`
	background: ${colors.grey.dark};
	border-color: ${colors.grey.dark};
	opacity: 0.8;
	color: #000;
	height: 38px;
	padding: 0 20px;
	border-radius: 4px;
	margin-top: 4px;

	&:hover,
	&:focus {
		background: ${colors.grey.normal};
		border-color: ${colors.grey.normal};
		color: #000;
	}

	&:active {
		background: ${colors.grey.normal};
		border-color: ${colors.grey.normal};
		color: #000;
	}
`;

const SearchInputWrapper = styled.div`
	& > div {
		input {
			font-size: 14px;
			border-radius: 4px !important;
			border-color: ${colors.grey.normal} !important;
		}
	}
`;

const SearchForm = ({ sendSearch, topBar = false, className = '' }) => (
	<form
		noValidate
		onSubmit={sendSearch}
		className={className}
		style={{ width: '100%', display: 'flex', alignItems: 'center' }}
	>
		<Row noWrap={topBar}>
			<Column shrink="0" grow="0" basis="400px">
				<SearchInputWrapper>
					<Field
						name="query"
						id="query"
						component={Input}
						noBorder={false}
						height={topBar ? '48px' : 'unset'}
						className={topBar ? '' : 'mb10'}
						placeholder="Search QSR, CR, manuals and SourceSafe"
					/>
				</SearchInputWrapper>
			</Column>

			{topBar ? (
				<Column shrink="0" grow="0" basis="auto" style={{ marginLeft: '8px' }}>
					<SearchButton type="submit" height="40px">
						SEARCH
					</SearchButton>
				</Column>
			) : (
				<Column grow="1" basis="70px">
					<Button height="39px" width="100%">
						Search
					</Button>
				</Column>
			)}
		</Row>
	</form>
);

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/Search/SearchForm.js